import { Maybe } from 'types/FMSGraphqlTypes'
import { TLoadTypesSchema } from '../components/LoadTypesModal/schema/LoadTypesSchema'
import { TCarrierLoadTypePreference } from '../types'

export const getLoadTypesDefaultValues = (
  loadingCapability: Maybe<TCarrierLoadTypePreference>
): TLoadTypesSchema => {
  const { isDropCapable, isLiveCapable, isPowerOnly } = loadingCapability || {}
  return {
    isLiveCapable: isLiveCapable || false,
    isDropCapable: isDropCapable || false,
    isPowerOnly: isPowerOnly || false,
  }
}
